import {
	readParametricByCode,
	type ParametricPartNoSource
} from "./parametricPartNos";

/*
	How many slots a structure pack asks the customer to fill. Norce cannot
	express this in the structure itself — a pool and a fixed bundle's contents
	are identical in the payload — so the intent comes from a parametric whose
	code is mapped per deployment (`NORCE_MANAGED_STRUCTURE_PACK_PARAMETRIC`).
	No code configured means the feature is off.
*/

/**
 * The configured code, or `""`. Guarded because the cart store reads it
 * outside a Nuxt context in unit tests.
 */
export const getPackParametricCode = (): string => {
	try {
		return (
			useRuntimeConfig().public?.norce?.managedStructurePackParametric ?? ""
		);
	} catch {
		return "";
	}
};

/** True when this deployment sells configurable packs. */
export const isManagedStructurePackEnabled = (
	parametricCode: string | undefined | null
): parametricCode is string => !!parametricCode;

/** Slots the picker should render; `0` means no picker. */
export const getPackChooseCount = (
	sources: (ParametricPartNoSource | undefined | null)[],
	parametricCode: string | undefined | null
): number => {
	if (!isManagedStructurePackEnabled(parametricCode)) return 0;

	const value = Number(readParametricByCode(sources, parametricCode));

	return Number.isFinite(value) && value > 0 ? Math.floor(value) : 0;
};
